module.exports = __webpack_public_path__ + "static/img/bg_buildpaper.41c59fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_buildpaper.jpg
// module id = q3o6
// module chunks = 1